<template>
  <div class="not-available">
  </div>
</template>

<script>
export default {
  name: "NotAvailableTableCell",
};
</script>

<style scoped>
.not-available {
  width: 100%;
  height: 100%;
  background-color: #dddddd;
}
</style>
